import Animated, { AnimatedStyle } from 'react-native-reanimated';

import { LeagueMenuIcon } from '@/assets/icons/menu';
import { Text } from '@/components/TextComponent';
import { Box, Row, TouchableBox } from '@/components/lib/components';

import { VIEW_ALL_WIDTH } from '../utils/league-navigator-utils';

type ViewAllLeaguesProps = {
    labelStyle: AnimatedStyle;
    onPress: () => void;
};

export const ViewAllLeagues = ({ labelStyle, onPress }: ViewAllLeaguesProps) => {
    return (
        <Row width={VIEW_ALL_WIDTH}>
            <TouchableBox justifyContent={'space-between'} alignItems={'center'} onPress={onPress}>
                <Box p={'s10'}>
                    <LeagueMenuIcon />
                </Box>
                <Animated.View style={labelStyle}>
                    <Text variant={'labelMedium'} textAlign={'center'} color={'neutral300'}>
                        All
                    </Text>
                </Animated.View>
            </TouchableBox>
        </Row>
    );
};
